const awsExports = {
    aws_project_region: "us-east-1",
    aws_cognito_region: "us-east-1",
    aws_user_pools_id: "ap-south-1_QyDcda7mu",
    aws_user_pools_web_client_id: "5p37l7fmvdpiqtd23qhgpciq99",
    Auth: {
      cookieStorage: {
        domain: 'https://prod.d2ltdm0eo32kq.amplifyapp.com/',  
        path: '/',
        expires: 7, 
        secure: true, 
      },
      
    }
  };
  
  export default awsExports;
  